import classNames from 'classnames/bind';
import { CommandBar, ICommandBarItemProps } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { IAppCommandBarProps } from '../../Models/Constants/Interfaces';
import { useContext } from 'react';
import { AppContext } from '../../Pages/App/App';
import styles from './AppCommandBar.module.scss';
const cx = classNames.bind(styles);

export const AppCommandBar: React.FC<IAppCommandBarProps> = ({
    userName,
    onSettingsClick,
    onToggleUserMenu
}) => {
    const { t } = useTranslation();
    const {
        setIs3DScenesSplashVisible
    } = useContext(AppContext);

    const getFarItems = () => {
        const userSettingsButtonStyles = {
            root: {
                width: 'auto !important',
                paddingLeft: '0 !important',
                paddingRight: '12px'
            },
            flexContainer: {
                flexDirection: 'row-reverse',
                borderLeft: '1px solid #666'
            },
            label: {
                maxWidth: '150px',
                textOverflow: 'ellipsis',
                padding: '0 8px',
                fontWeight: '400 !important',
                height: '15px'
            }
        };

        return [
            {
                key: 'settings',
                text: '',
                ariaLabel: t('settings'),
                iconProps: { iconName: 'Settings' },
                className: cx('app-toolbarButtons'),
                onClick: onSettingsClick
            },
            {
                key: 'help',
                text: '',
                ariaLabel: t('helpContent'),
                iconProps: { iconName: 'StatusCircleQuestionMark' },
                className: `${cx('app-toolbarButtons')} ${cx('app-helpButton')}`,
                onClick: () => setIs3DScenesSplashVisible(true)
            },
            {
                key: 'feedback',
                text: t('appCommandBar.feedback.text'),
                ariaLabel: t('appCommandBar.feedback.ariaLabel'),
                iconOnly: true,
                iconProps: { iconName: 'Emoji2' },
                onClick: () => {
                  (window as any).OfficeBrowserFeedback.multiFeedback()
                    // eslint-disable-next-line no-console
                    .catch((error: any) => console.error('Multi feedback failed: ', error));
                },
                className: cx('app-toolbarButtons')
            },
            {
                key: 'userSettings',
                text: userName,
                ariaLabel: 'user settings',
                iconOnly: false,
                iconProps: { iconName: 'PlayerSettings' },
                onClick: onToggleUserMenu,
                className: cx('app-toolbarButtons', 'settings-button'),
                buttonStyles: userSettingsButtonStyles
            }
        ] as ICommandBarItemProps[];
    };

    return (
        <div className={cx('app-commandbar-container')}>
            <CommandBar
                items={[]}
                farItems={getFarItems()}
                ariaLabel={t('useArrowKeysToNavigate')}
                className={cx('app-commandbar')}
            />
        </div>
    );
};
